import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const ErrorStep = ({content}) => {

  const {
    icon = {},
    title,
    subtitle,
    action,
    finishButton,
    purpleInnerDiv
  } = content;

  return (
    <div className='errorStep-main-container'>
      <div className='top-container'>
        {icon && <Image src={icon} alt='Error' className='error-icon' />}
        <span className='title'>{title}</span>
        {subtitle && <span className='subtitle'>{subtitle}</span>}
        {purpleInnerDiv && (
          <div className='purple-inner-div'>
            <div className='icon-and-title'>
              {purpleInnerDiv?.icon && <Image src={purpleInnerDiv?.icon} alt='Icon' className='purple-icon' />}
              {purpleInnerDiv?.title && <span className='purple-title'>{purpleInnerDiv?.title}</span>}
            </div>
            {purpleInnerDiv?.actions?.map((action, index) => action?.actionFunc(action?.text, action?.callback, index))}
          </div>
        )}
        {action}
      </div>
      {finishButton && <div className='bottom-container'>{finishButton}</div>}
    </div>
  );
};

export default ErrorStep;
